const templates =  {
    "shop.okraina.ru": {
        title: "Условия программы «Пригласи Друга»",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Условия программы «Пригласи Друга»",
        tags: [

        ]
    },
}

export default templates;